var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column"},[_c('PowerBIReportEmbedded',{attrs:{"reportId":"4ed59a38-9406-4382-b81c-62ef0b986daf","showFilters":false,"showPageNavigation":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }